import ContactForm from '../Common/ContactForm';

export default function SfpAeoBlock() {
  const lastUpdated = new Date().toISOString().split('T')[0];

  return (
    <section 
      style={{ padding: '60px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}
      aria-label="Seller Fulfilled Prime Summary"
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '40px', alignItems: 'start' }}>
        
        {/* Left Side: Summary / AEO Block */}
        <div style={{ background: '#ffffff', padding: '32px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', borderLeft: '5px solid #f97316' }}>
          
          <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '12px', fontWeight: 600 }}>
            Last Updated: {lastUpdated}
          </div>

          <h2 style={{ fontSize: '1.75rem', color: '#0f172a', marginBottom: '16px', fontWeight: 800 }}>
            Quick Summary: Seller Fulfilled Prime (SFP)
          </h2>
          
          <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: 1.7, marginBottom: '16px' }}>
            <strong>Top Summary & Definition:</strong> Seller Fulfilled Prime (SFP) allows high-performing Amazon sellers to display the Prime badge on their listings while fulfilling orders directly from their own (or a 3PL partner's) warehouse, bypassing Amazon FBA.
          </p>

          <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: 1.7, marginBottom: '16px' }}>
            <strong>Audience & Key Takeaway:</strong> This service is designed for established UK Amazon sellers who want the sales boost of the Prime badge but need more control over inventory, bespoke packaging, or multi-channel distribution. By partnering with Pick Pack Pro, you meet Amazon's strict next-day delivery SLAs without the high costs of FBA storage.
          </p>

          <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: 1.7, marginBottom: '0' }}>
            <strong>Source Citation:</strong> To qualify, merchants must maintain a 99% on-time shipping rate as per <a href="https://sell.amazon.co.uk/programmes/seller-fulfilled-prime" target="_blank" rel="noopener noreferrer" style={{ color: '#28479e', textDecoration: 'underline' }}>Amazon's official SFP requirements</a>.
          </p>
        </div>

        {/* Right Side: Contact Form */}
        <div style={{ background: '#ffffff', padding: '24px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0' }}>
          <h3 style={{ fontSize: '1.4rem', color: '#0f172a', marginBottom: '20px', fontWeight: 700 }}>
            Discuss Your SFP Requirements
          </h3>
          <ContactForm source="seller-fulfilled-prime-services" isShowShopify={false} />
        </div>

      </div>
    </section>
  );
}
